import z from "zod";

export type MemberRegistrationRequest = {
  uplinerId: number;
  requirementsForMembershipRegistration: string;
  email: string;
  lineId: string;
  prefixForName: string;
  otherPrefixesForNames: string;
  firstName: string;
  lastName: string;
  nationalIdNumber: string;
  birthdate: number | null;
  birthMonth: number | null;
  birthYear: number | null;
  mobilePhone: string;
  homePhone: string;
  workPhone: string;
  workPhoneExtensionNumber: string;
  maritalStatus: string;
  prefixForSpouseName: string;
  spouseFirstName: string;
  spouseLastName: string;
  nameOfTheLocation: string;
  roomOrFloor: string;
  addressNumber: string;
  villageNumber: string;
  soi: string;
  road: string;
  province: string;
  district: string;
  subDistrict: string;
  postalCode: string;
  bankAccountType: string;
  bank: string;
  bankBranch: string;
  bankAccountName: string;
  bankAccountNumber: string;
  occupation: string;
  otherOccupations: string;
  paCompany: string;
  paPlan: string;
  hasANonLifeInsuranceBrokerLicense: boolean;
  nonLifeInsuranceBrokerLicenseNumber: string | null;
  nonLifeInsuranceBrokerLicenseExpiredDate: number | null;
  nonLifeInsuranceBrokerLicenseExpiredMonth: number | null;
  nonLifeInsuranceBrokerLicenseExpiredYear: number | null;
  hasANonLifeInsuranceBrokerLifeLicense: boolean;
  nonLifeInsuranceBrokerLifeLicenseNumber: string | null;
  nonLifeInsuranceBrokerLifeLicenseExpiredDate: number | null;
  nonLifeInsuranceBrokerLifeLicenseExpiredMonth: number | null;
  nonLifeInsuranceBrokerLifeLicenseExpiredYear: number | null;
  beneficiaryFirstName: string;
  beneficiaryLastName: string;
  beneficiaryLastNationalIdNumber: string;
  nationalCardFileGDriveId: string;
  nationalCardFileGDriveIdPub: string;
  bankAccountFileGDriveId: string;
  bankAccountFileGDriveIdPub: string;
  nonLifeInsuranceBrokerFileGDriveId: string;
  nonLifeInsuranceBrokerFileGDriveIdPub: string;
  nonLifeInsuranceBrokerLifeFileGDriveId: string;
  nonLifeInsuranceBrokerLifeFileGDriveIdPub: string;
  signatureImageUrl: string;
  paymentSlipGDriveId: string;
  paymentSlipGDriveIdPub: string;
};

export const memberRegisterSchema = z.object({
  uplinerId: z.number(),
  requirementsForMembershipRegistration: z.string({
    message: "ความต้องการในการสมัครสมาชิกไม่ถูกต้อง",
  }),
  email: z.string({ message: "อีเมลไม่ถูกต้อง" }),
  lineId: z.string({ message: "ไลน์ไอดีไม่ถูกต้อง" }),
  prefixForName: z.string({ message: "คำนำหน้าชื่อไม่ถูกต้อง" }),
  otherPrefixesForNames: z.string(),
  firstName: z.string({ message: "ชื่อ (ผู้สมัคร)ไม่ถูกต้อง" }),
  lastName: z.string({ message: "นามสกุล (ผู้สมัคร)ไม่ถูกต้อง" }),
  nationalIdNumber: z.string({ message: "เลขบัตรประชาชนไม่ถูกต้อง" }),
  birthdate: z.optional(z.number({ message: "วัน/เดือน/ปี (เกิด)ไม่ถูกต้อง" })),
  birthMonth: z.optional(
    z.number({ message: "วัน/เดือน/ปี (เกิด)ไม่ถูกต้อง" })
  ),
  birthYear: z.optional(z.number({ message: "วัน/เดือน/ปี (เกิด)ไม่ถูกต้อง" })),
  mobilePhone: z.string({ message: "โทรศัพท์มือถือไม่ถูกต้อง" }),
  homePhone: z.string(),
  workPhone: z.string(),
  workPhoneExtensionNumber: z.string(),
  maritalStatus: z.string(),
  prefixForSpouseName: z.string(),
  spouseFirstName: z.string(),
  spouseLastName: z.string(),
  nameOfTheLocation: z.string({
    message: "ชื่อสถานที่ อาคาร / บริษัท / หมู่บ้าน ไม่ถูกต้อง",
  }),
  roomOrFloor: z.string(),
  addressNumber: z.string({ message: "เลขที่ไม่ถูกต้อง" }),
  villageNumber: z.string({ message: "หมู่ที่ไม่ถูกต้อง" }),
  soi: z.string(),
  road: z.string(),
  province: z.string({ message: "จังหวัดไม่ถูกต้อง" }),
  district: z.string({ message: "เขต/อำเภอไม่ถูกต้อง" }),
  subDistrict: z.string({ message: "แขวง/ตำบลไม่ถูกต้อง" }),
  postalCode: z.string({ message: "รหัสไปรษณีย์ไม่ถูกต้อง" }),
  bankAccountType: z.string({ message: "ข้อมูลธนาคารไม่ถูกต้อง" }),
  bank: z.string(),
  bankBranch: z.string(),
  bankAccountName: z.string(),
  bankAccountNumber: z.string(),
  occupation: z.string(),
  otherOccupations: z.string(),
  paCompany: z.string(),
  paPlan: z.string(),
  hasANonLifeInsuranceBrokerLicense: z.boolean(),
  nonLifeInsuranceBrokerLicenseNumber: z.string().nullish(),
  nonLifeInsuranceBrokerLicenseExpiredDate: z.number().nullish(),
  nonLifeInsuranceBrokerLicenseExpiredMonth: z.number().nullish(),
  nonLifeInsuranceBrokerLicenseExpiredYear: z.number().nullish(),
  hasANonLifeInsuranceBrokerLifeLicense: z.boolean(),
  nonLifeInsuranceBrokerLifeLicenseNumber: z.string().nullish(),
  nonLifeInsuranceBrokerLifeLicenseExpiredDate: z.number().nullish(),
  nonLifeInsuranceBrokerLifeLicenseExpiredMonth: z.number().nullish(),
  nonLifeInsuranceBrokerLifeLicenseExpiredYear: z.number().nullish(),
  beneficiaryFirstName: z.string(),
  beneficiaryLastName: z.string(),
  beneficiaryLastNationalIdNumber: z.string(),
  nationalCardFileGDriveId: z.string({ message: "สำเนาบัตรประชาชนไม่ถูกต้อง" }),
  nationalCardFileGDriveIdPub: z.string({
    message: "สำเนาบัตรประชาชนไม่ถูกต้อง",
  }),
  bankAccountFileGDriveId: z.string({ message: "หน้าสมุดบัญชีไม่ถูกต้อง" }),
  bankAccountFileGDriveIdPub: z.string({ message: "หน้าสมุดบัญชีไม่ถูกต้อง" }),
  nonLifeInsuranceBrokerFileGDriveId: z.string(),
  nonLifeInsuranceBrokerFileGDriveIdPub: z.string(),
  nonLifeInsuranceBrokerLifeFileGDriveId: z.string(),
  nonLifeInsuranceBrokerLifeFileGDriveIdPub: z.string(),
  signatureImageUrl: z.string({
    message: "ลายเซ็นสำหรับใบสมัครสมาชิกศรีกรุงไม่ถูกต้อง",
  }),
  paymentSlipGDriveId: z.string(),
  paymentSlipGDriveIdPub: z.string(),
});
